import useLocationSearch from "../useLocationSearch";

export function useCurrentMenuParams() {
  const searchString = useLocationSearch();
  const params = new URLSearchParams(searchString);
  const currentParams = [];
  params.forEach((value, key) => {
    if (key === "category" || key === "sort") {
      currentParams.push(`${key}=${value}`);
    }
  });
  return currentParams;
}
